export const KEYWORD_MAX_LIMIT = 100;

export const SEARCH_LOCATION_RADIUS_DEFAULT = 10;
export const SEARCH_LOCATION_RADIUS_MAX = 100;
export const SEARCH_LOCATION_MAX_ALLOWED = 50;
export const SEARCH_AOIID_MAX_ALLOWED = 50;
export const SEARCH_NAME_MAX_LENGTH = 25;

export const SAVED_SEARCH_BOUND_TYPE_MAP_EXTENT = "mapextent";
export const SAVED_SEARCH_BOUND_TYPE_WORLD_WIDE = "worldwide";
export const SAVED_SEARCH_BOUND_TYPE_PLACES = "places";
export const SAVED_SEARCH_BOUND_TYPE_ASSETS = "assets";
export const SAVED_SEARCH_BOUND_TYPE_GEOGRAPHY = "geography";
export const SAVED_SEARCH_BOUND_TYPE_COUNTRIES = "countries";
export const SAVED_SEARCH_BOUND_TYPE_CITIES = "cities";
export const SAVED_SEARCH_BOUND_TYPE_CUSTOM = "custom";
export const SAVED_SEARCH_BOUND_TYPE_POLYGON = "polygon";
export const SAVED_SEARCH_BOUND_TYPES = [
  SAVED_SEARCH_BOUND_TYPE_MAP_EXTENT,
  SAVED_SEARCH_BOUND_TYPE_WORLD_WIDE,
  SAVED_SEARCH_BOUND_TYPE_COUNTRIES,
  SAVED_SEARCH_BOUND_TYPE_CITIES,
  SAVED_SEARCH_BOUND_TYPE_CUSTOM,
  SAVED_SEARCH_BOUND_TYPE_PLACES,
  SAVED_SEARCH_BOUND_TYPE_ASSETS,
  SAVED_SEARCH_BOUND_TYPE_GEOGRAPHY,
  SAVED_SEARCH_BOUND_TYPE_POLYGON,
];
